/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import { jwtDecode } from "jwt-decode";
import Navbar from "../Navbar";
import Header from "../Header";
import baseUrl from "../BaseUrl";
import Loader from "../Loader";
import { useNavigate , Link, useParams} from 'react-router-dom';
import Pagination from "react-js-pagination";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import SignalPopup from '../heart-rate-sessions/SignalPopup';
import { showTimeInSec, formatISODateToLocal } from "../../utils/utils";
 
const MonitorSessionData = () => {

    const { id } = useParams();
    const [name, setName] = useState('');
    const [token, setToken] = useState('');
    const [expire, setExpire] = useState('');
    // const [access, setAccess] = useState([]);
    const [popupOpen, setPopupOpen] = useState(false);
    const [users, setData] = useState([]);
    //const [userCount, setUserCount] = useState(0);
    const [totalItem, setTotalItem] = useState(0);
    const [page, setPage] = useState(1);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [displayFromDate, setDisplayFromDate] = useState("");
    const [displayToDate, setDisplayToDate] = useState("");
    const [searchValue, setSearchValue] = useState('');
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [popupData, setPopupData] = useState(null);
    const [watchFilter, setWatchFilter] = useState('');

    const navigate = useNavigate();

    useEffect(() => {
        refreshToken();
    }, []);

    useEffect(() => {
        setName('Pauser');
        getData('1','','','','');
    }, []);

   
    const refreshToken = async () => {
        try {
            const response = await axios.get(`${baseUrl}/admin/api/token`);
            setToken(response.data.accessToken);
            const decoded = jwtDecode(response.data.accessToken);
            setExpire(decoded.exp);
        } catch (error) {
           console.log(error.response)
            if (error.response) {
                // setError("Unauthorized");
               navigate("/");  
               window.location.reload();
            }
        }
    }


    const getData = async (page, fromDate,toDate,search,watchFilter) => {
        // console.log(page);
        setPopupOpen(true);

        const queryParams = new URLSearchParams({
            ...(id && { user_id: atob(id) }), // Include user_id only if id exists
            search: search,
            page: page,
            limit: 20,
            from_date: fromDate,
            to_date: toDate,
            ...(watchFilter && { watch_filter: watchFilter }), // Include watch_filter only if it exists
          });
          
        const response = await axiosJWT.get(`${baseUrl}/admin/api/monitor-sessions?${queryParams.toString()}`,{
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        setPopupOpen(false);
        setData(response.data.data); // Set the response data
        setTotalItem(response.data.totalItem);        
    }

    const axiosJWT = axios.create();
 
    axiosJWT.interceptors.request.use(async (config) => {
        const currentDate = new Date();
        if (expire * 1000 < currentDate.getTime()) {
            const response = await axios.get(`${baseUrl}/admin/api/token`);
            config.headers.Authorization = `Bearer ${response.data.accessToken}`;
            setToken(response.data.accessToken);
            const decoded = jwtDecode(response.data.accessToken);
            setExpire(decoded.exp);
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });

    const handlePageChange  = (pageNumber) => {
        // console.log(`active page is ${pageNumber}`);
        setPage(pageNumber);
        getData(pageNumber,fromDate,toDate,searchValue,watchFilter);
    }

    
    const handleFromDate = (date) => {
        if (!date) {
            setFromDate('');
            setDisplayFromDate('');
            return;
        }
        const formattedDate =
        date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' +
         date.getDate().toString().padStart(2, '0');

        setFromDate(formattedDate);
        setDisplayFromDate(date);
    };
    const handleToDate = (date) => {
        if (!date) {
            setToDate('');
            setDisplayToDate('');
            return;
        }
        const formattedDate =
        date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' +
         date.getDate().toString().padStart(2, '0');

        setToDate(formattedDate);
        setDisplayToDate(date);
    };

    const handleSearchSubmit = () => {
        setPage(1);
        getData(1,fromDate,toDate,searchValue,watchFilter);
    };

    const handleSearchChange = (e) => {
        setSearchValue(e.target.value);
    };

    const clearFilter = () => {
        setFromDate('');
        setDisplayFromDate('');
        setToDate('');
        setDisplayToDate('');
        setSearchValue('');
        setWatchFilter('');
        setPage(1);
        getData(1,'','','','');
    }
    
    const handleRowClick = (row) => {
        setPopupData(row);
        setIsPopupOpen(true);
    };

    const closePopup = () => {
        setIsPopupOpen(false);
        setPopupData(null);
    };
  
    
    return (
        <div className="panelbox">
           <Navbar />
            <div className="right-panel">
            <Header name={name} />
            {popupOpen && (
                     <Loader /> 
                ) }
                <div className="content-page">
                    <div className="row">
                        <div className="col-6">
                            <div className="left-title">
                                <h1>Monitor Sessions</h1>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="addnew-button">
                                <Link to="/user-monitor-sessions"><span>&larr;</span> Back</Link>
                            </div>
                        </div>
                    </div>
                    <div className="row numberboxes">
                         <div className="col-md-3">
                            <div className="dashboard-box" id="number">
                                <h3>Total Sessions</h3>
                                <p>{totalItem}</p>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 order-filter transection-filter">
                            <div className="boxinput">

                                <input className="search-leave satff-listing-page-search" type="text" name="search" placeholder="Search" value={searchValue} onChange={handleSearchChange} /> 
                              
                                <select className="form-control" name="watchFilter" value={watchFilter} onChange={(e) => setWatchFilter(e.target.value)}>
                                    <option value="">From Device</option>
                                    <option value="from_watch">From Watch</option> 
                                    <option value="from_mobile">From Mobile</option>
                                    <option value="from_other">From Other</option>   
                                </select>

                                <DatePicker
                                    selected={displayFromDate}
                                    onChange={handleFromDate}
                                    dateFormat="dd/MM/yyyy" // Set the desired date format
                                    placeholderText="From Date"
                                    className="from-date"
                                />
                                <DatePicker
                                    selected={displayToDate}
                                    onChange={handleToDate}
                                    dateFormat="dd/MM/yyyy" // Set the desired date format
                                    placeholderText="To Date"
                                    className="end-date"
                                />  
                                
                                <button  className="search-btn" onClick={handleSearchSubmit}>Search</button>
                               { (fromDate || toDate || searchValue || watchFilter) && (<button type="button" className='search-btn clear-btn' onClick={clearFilter} >Clear</button>)}
                            </div>
                        </div>
                        
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="fullwidth-table track-table-body staff-listing-admin-table-body">
                                <table className="table is-striped is-fullwidth">
                                    <thead>
                                        <tr>
                                            <th>No</th>
                                            <th>Name</th>
                                            <th>Perform time</th>
                                            <th>Session time</th>
                                            <th>Session name</th>
                                            <th>From Device</th>
                                            <th>Session Date</th>
                                            <th>Signal Details</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {users && users.map((user) => (
                                            <tr key={user.id}>
                                                <td data-label="No">{user.id}</td>
                                                <td data-label="Name">{user.name}</td>
                                                <td data-label="Perform time">{showTimeInSec(user.session_perform_time)}</td>
                                                <td data-label="Session time">{showTimeInSec(user.session_time)}</td>
                                                <td data-label="Session name">{user.session_name}</td>
                                                <td data-label="From Device">
                                                    {user.is_from_watch === "true" ? 'Watch' :
                                                     user.is_from_watch === "false" ? 'Mobile' : 'Other'}
                                                </td>
                                                <td data-label="Session Date">{formatISODateToLocal(user.timestamp_utc_formatted)}</td>
                                                <td data-label="Signal Details"><button type="button"  onClick={() => handleRowClick(user.row_hr_details)}><img src={`${process.env.PUBLIC_URL}/images/view.png`} alt="Signal details" title="Use this option to show signal details"/></button></td>
                                            </tr>
                                        ))
                                    }
                                    </tbody>
                                </table>
                                {totalItem > 20 && (<Pagination
                                  activePage={page}
                                  itemsCountPerPage={20}
                                  totalItemsCount={totalItem}
                                  pageRangeDisplayed={5}
                                  onChange={handlePageChange.bind(this)}
                                />)}
                                {isPopupOpen && (
                                    <SignalPopup data={popupData} onClose={closePopup} />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    )
}
 
export default MonitorSessionData